import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Navigation, NavigationResponse, NavigationSteps, NavigationStepsResponse } from '../models/navigation.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { Message } from '../models/message';

@Injectable()
export class NavigationService {
    private baseUrl: string;
    private api: string = "api/Navigation";
    
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Navigation Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

  async createNavigationWizardAsync(encryptedUser: string, navigationResponse: NavigationResponse): Promise<NavigationResponse | void> {
    const a = await this.httpClient.post<NavigationResponse>(`${this.baseUrl}/NavigationWizard_Create`, navigationResponse, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, navigationResponse, "", encryptedUser, "NavigationService", "createNavigationWizardAsync"); });


        return a;
    }

  async getNavigationStepsAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<NavigationStepsResponse | void> {
        const a = await this.httpClient
          .get<NavigationStepsResponse>(`${this.baseUrl}/NavigationSteps_Get/${inventionId}/${contractSessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
          }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId + " contractSessionId - " + contractSessionId, encryptedUser, "NavigationService", "getNavigationStepsAsync"); });


        return a;
    }

  async getSignalRMessageAsync(encryptedUser: string): Promise<Message | void> {
    const a = await this.httpClient
      .get<NavigationStepsResponse>(`${this.baseUrl}/SignalRMessage_Get`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, encryptedUser, "NavigationService", "getSignalRMessageAsync"); });


    return a;
  }

  async getNavigationWizardAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<NavigationResponse | void> {
    const a = await this.httpClient
      .get<NavigationResponse>(`${this.baseUrl}/NavigationWizard_Get/${inventionId}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser,
          'Retry-After':'15'
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId + " contractSessionId - " + contractSessionId, encryptedUser, "NavigationService", "getNavigationWizardAsync"); });
 

    return a;
  }
}
